const types = {
  RECEIVED_ALLOCATIONS: "ALLOCATION_SELECTION/RECEIVED_ALLOCATIONS",
  RECEIVED_CENTRALIZED_GIFTS: "ALLOCATION_SELECTION/RECEIVED_CENTRALIZED_GIFTS",
  MODAL_ERROR_RECEIVING: "ALLOCATION_SELECTION/RECEIVED_CAUSES_ERROR_RECEIVING",
  MODAL_UPDATE_QUERY_STRING: "ALLOCATION_SELECTION/UPDATE_QUERY_STRING",
  MODAL_DEFINITELY_STOP_LOADER: "ALLOCATION_SELECTION/DEFINITELY_STOP_LOADER",
  MODAL_START_LOADER: "ALLOCATION_SELECTION/START_LOADER",
  SELECT_ALLOCATION: "ALLOCATION_SELECTION/SELECT_ALLOCATION",
  MODAL_SET_USER_ID: "ALLOCATION_SELECTION/SET_USER_ID",
  MODAL_SET_NEW_AMOUNT: "ALLOCATION_SELECTION/SET_NEW_AMOUNT",
  MODAL_SET_AMOUNT: "ALLOCATION_SELECTION/SET_AMOUNT",
  MODAL_SET_TO_AVERAGE_DONATION: "ALLOCATION_SELECTION/SET_TO_AVERAGE_DONATION",
  MODAL_SET_DONATION_TOKEN: "ALLOCATION_SELECTION/MODAL_SET_DONATION_TOKEN",
  MODAL_SET_QUERY: "ALLOCATION_SELECTION/SET_QUERY",
  RESET_ALLOCATIONS: "ALLOCATION_SELECTION/RESET_ALLOCATIONS",
  MODAL_SET_AMOUNT_FROM_FORM: "ALLOCATION_SELECTION/SET_AMOUNT_FROM_FORM",
  MODAL_SET_DONATION_ID: "ALLOCATION_SELECTION/SET_DONATION_ID",
  RESET_SELECTED_ALLOCATIONS: "ALLOCATION_SELECTION/RESET_SELECTED_ALLOCATIONS",
  DELETE_SELECTED_ALLOCATIONS: "ALLOCATION_SELECTION/DELETE_SELECTED_ALLOCATIONS",
  MODAL_SUBMITTING_FORM: "ALLOCATION_SELECTION/SUBMITTING_FORM",
  MODAL_FORM_SUBMITTED: "ALLOCATION_SELECTION/FORM_SUBMITTED",
  FETCHED_ALLOCATIONS: "ALLOCATION_SELECTION/FETCHED_ALLOCATIONS",
  SELECT_CATEGORY: "ALLOCATION_SELECTION/SELECT_CATEGORY",
  SET_GATEWAY_ERROR: "ALLOCATION_SELECTION/SET_GATEWAY_ERROR",
  TRIGGER_IS_MOUNTED: "ALLOCATION_SELECTION/TRIGGER_IS_MOUNTED",
  SET_MINIMUM_VALUE_ERROR: "ALLOCATION_SELECTION/SET_MINIMUM_VALUE_ERROR",
  CONFIRMING_CHANGED: "ALLOCATION_SELECTION/CONFIRMING_CHANGED",
  ADDING_GIFT_CHANGED: "ALLOCATION_SELECTION/ADDING_GIFT_CHANGED",
  SELECT_CART_ALLOCATIONS: "ALLOCATION_SELECTION/SELECT_CART_ALLOCATIONS",
  STRIPE_PAYMENT_ID_CHANGED: "ALLOCATION_SELECTION/STRIPE_PAYMENT_ID_CHANGED",
  STRIPE_CONNECTED_ACCOUNT_ID: "ALLOCATION_SELECTION/STRIPE_CONNECTED_ACCOUNT_ID",
  STRIPE_CLIENT_SECRET_KEY: "ALLOCATION_SELECTION/STRIPE_CLIENT_SECRET_KEY",
  STRIPE_PUBLISHABLE_KEY: "ALLOCATION_SELECTION/STRIPE_PUBLISHABLE_KEY",
  STRIPE_OBJECT: "ALLOCATION_SELECTION/STRIPE_OBJECT",
  STRIPE_ELEMENTS_OBJECT: "ALLOCATION_SELECTION/STRIPE_ELEMENTS_OBJECT",
  IS_GIFT_AID: "ALLOCATION_SELECTION/IS_GIFT_AID",
  AMOUNT_WITH_GIFT_AID: "ALLOCATION_SELECTION/AMOUNT_WITH_GIFT_AID",
  STRIPE_PAYMENT_INTENT_ID: "ALLOCATION_SELECTION/STRIPE_PAYMENT_INTENT_ID",
  RESET_SUBMIT_ERROR: "ALLOCATION_SELECTION/RESET_SUBMIT_ERROR",
  UPDATE_ALLOCATION_AMOUNT: "ALLOCATION_SELECTION/UPDATE_ALLOCATION_AMOUNT",
  SET_FEE_AMOUNT: "ALLOCATION_SELECTION/SET_FEE_AMOUNT",
};

export default types;

export const MINIMUM_WAIT_FOR_RESPONSE = 5000;
export const WAIT_TO_SHOW_CONTENT = 750;
export const PAGE_LIMIT = 12;
export const DONATION_AMOUNT = 1000;
